//
// Authoriziation store
//
// Handles API authentication (login/logout) and stores auth token for
// further API communication.
//

import Raven from 'raven-js';
import * as client from 'api/client';
import { fetchUserData } from './user';
import { fetchContent } from '../actions';

// ------------------------------------
// Action definitions
// ------------------------------------

export const AUTHENTICATE = 'AUTH/AUTHENTICATE';
export const INVALIDATE = 'AUTH/INVALIDATE';
export const LOGIN = 'AUTH/LOGIN';
export const LOGOUT = 'AUTH/LOGOUT';
export const ERROR = 'AUTH/ERROR';

// ------------------------------------
// Action creators
// ------------------------------------

export const authenticate = (email, password, remember) => (dispatch) => {
  dispatch({ type: AUTHENTICATE });

  return client.post('/api/login', { email, password })
    .then(json => {
      Raven.setUserContext({ email });
      dispatch(login(json.token, remember));
    })
    .catch(error => dispatch(fail()));
};

export const login = (token, remember) => dispatch => {
  if (remember) localStorage.setItem('token', token);

  dispatch({ type: LOGIN, token});
  dispatch(fetchUserData());
};

export const logout = () => dispatch => {
  localStorage.removeItem('token');
  Raven.setUserContext();
  dispatch({ type: LOGOUT });
  dispatch(fetchContent());
};

export const invalidate = () => dispatch => {
  localStorage.removeItem('token');
  dispatch({ type: INVALIDATE });
};

export const fail = () => ({ type: ERROR });

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  authenticating: false,
  error: false,
  token: null
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTHENTICATE:
      return {
        ...state,
        authenticating: true,
        error: false
      };

    case LOGIN:
      return {
        ...initialState,
        token: action.token
      };

    case LOGOUT:
    case INVALIDATE:
      return initialState;

    case ERROR:
      return {
        ...initialState,
        error: true
      };

    default:
      return state
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getToken = state => state.auth.token;



// WEBPACK FOOTER //
// ./src/store/modules/auth.js